import React, { ReactNode, useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks/hooks";
import { ReactComponent as ErrorIcon } from "./Icons/errorAlert.svg";
import { ReactComponent as SuccessIcon } from "./Icons/successAlert.svg";
import { ReactComponent as WarnIcon } from "./Icons/warnAlert.svg";

import {
    selectAlertData,
    setAlert,
} from "../../app/features/alertSlice/alertSlice";
import classes from "./Alert.module.css";
function Alert({}) {
    const alertData = useAppSelector(selectAlertData);
    const dispatch = useAppDispatch();
    const [exIndex, setExIndex] = useState(0);
    useEffect(() => {
        if (!alertData) return;
        const index = alertData.index;
        setTimeout(() => {
            setExIndex((ex) => {
                if (ex === index) {
                    dispatch(setAlert(null));
                }
                return ex;
            });
        }, alertData.time);
        setExIndex(alertData.index!);
    }, [alertData]);

    if (!alertData) return <></>;
    let CurIcon: ReactNode;
    switch (alertData.type) {
        case "error":
            CurIcon = (
                <ErrorIcon
                    className={[classes.errorIcon, classes.icon].join(" ")}
                    style={{ stroke: "rgb(239 46 46)" }}
                />
            );
            break;
        case "info":
            CurIcon = (
                <WarnIcon
                    className={[classes.infoIcon, classes.icon].join(" ")}
                />
            );
            break;
        case "success":
            CurIcon = (
                <SuccessIcon
                    className={[classes.successIcon, classes.icon].join(" ")}
                />
            );
            break;
        case "warn":
            CurIcon = (
                <WarnIcon
                    className={[classes.warnIcon, classes.icon].join(" ")}
                />
            );
            break;
        default:
            CurIcon = (
                <ErrorIcon
                    className={[classes.errorIcon, classes.icon].join(" ")}
                />
            );
            break;
    }
    return (
        <div className={classes.alertWrap}>
            <div
                className={[classes.alertBody, classes[alertData.type]].join(
                    " "
                )}
            >
                {CurIcon}
                {/* <curIcon className={classes.alertIcon}></curIcon> */}
                <div className={classes.alertText}>{alertData.message}</div>
            </div>
        </div>
    );
}

export default Alert;
